import {
  aiChatbotAnswerFeedbackClickedSrc4Evid1137,
  aiChatbotAnswerFeedbackFreeTextSrc4Evid1139,
  aiChatbotAnswerFeedbackPresentedSrc4Evid1136,
  aiChatbotAnswerFeedbackReasonButtonClickedSrc4Evid1138,
  aiChatbotResendButtonClickedSrc4Evid1173,
  aiChatbotShowSourcesButtonClickedInAnAnswerSrc4Evid1149,
  caraVoiceAssistantCaraIsOfferedSrc4Evid112,
  chatbotClickButtonOnHeaderSrc4Evid1146,
  chatbotClickLink,
  chatbotClickOnSolution,
  chatbotConnectionLostMessagePresentedSrc4Evid1175,
  chatbotContactFlowQuickAccessAvailableSrc4Evid1134,
  chatbotConversationCreatedFromStartOver,
  chatbotDisplayWarning,
  chatbotErrorMessageAppearsSrc4Evid7401,
  chatbotErrorMessagePresentedSrc4Evid1172,
  chatbotGeneralClientLog,
  chatbotHelpmateSatisfactionSurveyInteractionSrc4Evid1148,
  chatbotLoadChatbot,
  chatbotNotifications,
  chatbotSendMessageSrc4Evid7400,
  chatbotStartOver,
  chatbotStatusBannerStatusBannerClicked,
  chatbotStatusBannerStatusBannerDismissed,
  chatbotStatusBannerStatusBannerShowed,
  fullContactPageArticleEngagementSrc4Evid1521,
  fullContactPageArticleViewSrc4Evid1520,
  helpWidgetClickOnAnswerOrResultNewSrc4Evid1510,
  helpWidgetItemClickNewSrc4Evid1506,
  helpWidgetItemOnViewNewSrc4Evid1505,
  helpWidgetPageEngagementNewSrc4Evid1504,
  helpWidgetPageErrorNewSrc4Evid1507,
  helpWidgetPageViewNewSrc4Evid1502,
  helpWidgetSearchResultsNewSrc4Evid1509,
  keraVoiceAssistantSessionEndSrc4Evid102,
  pageClick,
  schedulerUserChoosesADay,
  schedulerUserClickedOnASlot,
  schedulerUserSearchedADifferentMonth,
  wixContactClickOnALinkInsideASolution,
  wixContactClickOnTheActionButton,
} from '@wix/bi-logger-customer-care-data/v2';
import type {
  aiChatbotAnswerFeedbackClickedSrc4Evid1137Params,
  aiChatbotAnswerFeedbackFreeTextSrc4Evid1139Params,
  aiChatbotAnswerFeedbackPresentedSrc4Evid1136Params,
  aiChatbotAnswerFeedbackReasonButtonClickedSrc4Evid1138Params,
  aiChatbotResendButtonClickedSrc4Evid1173Params,
  aiChatbotShowSourcesButtonClickedInAnAnswerSrc4Evid1149Params,
  caraVoiceAssistantCaraIsOfferedSrc4Evid112Params,
  chatbotClickButtonOnHeaderSrc4Evid1146Params,
  chatbotClickLinkParams,
  chatbotClickOnSolutionParams,
  chatbotConnectionLostMessagePresentedSrc4Evid1175Params,
  chatbotContactFlowQuickAccessAvailableSrc4Evid1134Params,
  chatbotConversationCreatedFromStartOverParams,
  chatbotDisplayWarningParams,
  chatbotErrorMessageAppearsSrc4Evid7401Params,
  chatbotErrorMessagePresentedSrc4Evid1172Params,
  chatbotGeneralClientLogParams,
  chatbotHelpmateSatisfactionSurveyInteractionSrc4Evid1148Params,
  chatbotLoadChatbotParams,
  chatbotNotificationsParams,
  chatbotSendMessageSrc4Evid7400Params,
  chatbotStartOverParams,
  chatbotStatusBannerStatusBannerClickedParams,
  chatbotStatusBannerStatusBannerDismissedParams,
  chatbotStatusBannerStatusBannerShowedParams,
  fullContactPageArticleEngagementSrc4Evid1521Params,
  fullContactPageArticleViewSrc4Evid1520Params,
  helpWidgetClickOnAnswerOrResultNewSrc4Evid1510Params,
  helpWidgetItemClickNewSrc4Evid1506Params,
  helpWidgetItemOnViewNewSrc4Evid1505Params,
  helpWidgetPageEngagementNewSrc4Evid1504Params,
  helpWidgetPageErrorNewSrc4Evid1507Params,
  helpWidgetPageViewNewSrc4Evid1502Params,
  helpWidgetSearchResultsNewSrc4Evid1509Params,
  keraVoiceAssistantSessionEndSrc4Evid102Params,
  LogObject,
  pageClickParams,
  schedulerUserChoosesADayParams,
  schedulerUserClickedOnASlotParams,
  schedulerUserSearchedADifferentMonthParams,
  wixContactClickOnALinkInsideASolutionParams,
  wixContactClickOnTheActionButtonParams,
} from '@wix/bi-logger-customer-care-data/v2/types';
import { factory } from '@wix/web-bi-logger';

import { TRootState } from '../common/reducers';
import { selectSearchSessionId } from '../common/selectors/helpCenter';
import { selectLoadPageUrl, selectReferral } from '../common/selectors/meta';
import { renderModel } from '../util/renderModel';
import { parentUrl, referral, referralUrl } from './constants';
import { RequiredWithUndefined } from './types';
import { createOnError, getSharedBiFieldsFromState, toAbsoluteUrl } from './utils';

export type SitePickerEventSrc4Evid1147Params = {
  action_type:
    | 'site_picker_visible'
    | 'site_picker_open'
    | 'site_picker_site_change'
    | 'site_picker_remove_site';
  current_msid?: string;
  number_of_site?: number;
  chosen_msid?: string;
  page_language?: string;
  context_url?: string;
  conversation_id?: string;
  self_service_session_id?: string;
  target_account_id?: string;
};

function sitePickerEventSrc4Evid1147(
  params: SitePickerEventSrc4Evid1147Params,
): LogObject<SitePickerEventSrc4Evid1147Params> {
  return { evid: 1147, src: 4, endpoint: '', params };
}

const accountId = renderModel.getAccountId();
const defaultBiFields = {
  bot_id: '717b0e2d-a564-4ef7-b965-481b1983133b',
  provider: 'answers',
  referral_url: referralUrl,
  parent_url: parentUrl,
  target_account_id: accountId,
  referral,
};

type BiParams<T> = Readonly<
  // __cookies_prefix__wixLanguage - tech solution related to migration to catalog v2. Do not need to send it for now.
  Omit<RequiredWithUndefined<T>, keyof typeof defaultBiFields | '__cookies_prefix__wixLanguage'>
>;

class BiLogger {
  private readonly _answerLogger = factory({ endpoint: 'ans_bi' }).updateDefaults(defaultBiFields).logger();
  private readonly _chatbotLogger = factory({ endpoint: 'chatbot' }).updateDefaults(defaultBiFields).logger();

  /**
   * Enhanced report method that automatically injects shared fields for new events
   * @param state - Redux state for extracting shared context fields
   * @param eventFunction - BI event function that takes params and returns event data
   * @param eventId - Event ID for error handling
   * @param params - Partial event parameters (shared fields will be auto-injected)
   */
  private async reportWithAutoEnhancement<T extends Record<string, any>>(
    state: TRootState,
    eventFunction: (params: T) => any,
    eventId: number,
    params: Partial<T>,
  ): Promise<void> {
    try {
      const referralFromState = selectReferral(state);
      const referralFromSession = sessionStorage.getItem('referral');
      const parent_url = selectLoadPageUrl(state);

      const sharedFields = await getSharedBiFieldsFromState(state);
      const enhancedParams = { ...sharedFields, ...params } as T;
      await this._chatbotLogger
        .updateDefaults({
          ...defaultBiFields,
          parent_url: parent_url ?? defaultBiFields.parent_url,
          referral: referralFromState ?? referralFromSession ?? defaultBiFields.referral,
        })
        .report(eventFunction(enhancedParams));
    } catch (error) {
      createOnError(eventId, params)(error);
    }
  }

  // 574
  wixContactClickOnTheActionButton(params: BiParams<wixContactClickOnTheActionButtonParams>): void {
    this._answerLogger.report(wixContactClickOnTheActionButton(params)).catch(createOnError(574, params));
  }

  // 575
  wixContactClickOnALinkInsideASolution(params: BiParams<wixContactClickOnALinkInsideASolutionParams>): void {
    this._answerLogger
      .report(wixContactClickOnALinkInsideASolution(params))
      .catch(createOnError(575, params));
  }

  // 102
  async keraVoiceAssistantSessionEnd(
    params: BiParams<keraVoiceAssistantSessionEndSrc4Evid102Params>,
  ): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(keraVoiceAssistantSessionEndSrc4Evid102(params))
      .catch(createOnError(102, params));
  }

  // 41
  async chatbotConversationCreatedFromStartOver(
    params: BiParams<chatbotConversationCreatedFromStartOverParams>,
  ): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(chatbotConversationCreatedFromStartOver(params))
      .catch(createOnError(41, params));
  }

  // 1051
  async chatbotLoadChatbot(params: BiParams<chatbotLoadChatbotParams>): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(chatbotLoadChatbot(params))
      .catch(createOnError(1051, params));
  }

  // 1054
  async chatbotStartOver(params: BiParams<chatbotStartOverParams>): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(chatbotStartOver(params))
      .catch(createOnError(1054, params));
  }

  // 1088
  async chatbotClickLink(params: BiParams<chatbotClickLinkParams>): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(chatbotClickLink(params))
      .catch(createOnError(1088, params));
  }

  // 1123
  async chatbotDisplayWarning(params: BiParams<chatbotDisplayWarningParams>): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(chatbotDisplayWarning(params))
      .catch(createOnError(1123, params));
  }

  // 1127
  async chatbotStatusBannerStatusBannerShowed(
    params: BiParams<chatbotStatusBannerStatusBannerShowedParams>,
  ): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(chatbotStatusBannerStatusBannerShowed(params))
      .catch(createOnError(1127, params));
  }

  // 1128
  async chatbotStatusBannerStatusBannerClicked(
    params: BiParams<chatbotStatusBannerStatusBannerClickedParams>,
  ): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(chatbotStatusBannerStatusBannerClicked(params))
      .catch(createOnError(1128, params));
  }

  // 1129
  async chatbotStatusBannerStatusBannerDismissed(
    params: BiParams<chatbotStatusBannerStatusBannerDismissedParams>,
  ): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(chatbotStatusBannerStatusBannerDismissed(params))
      .catch(createOnError(1129, params));
  }

  // 1151
  async schedulerUserSearchedADifferentMonth(
    params: BiParams<schedulerUserSearchedADifferentMonthParams>,
  ): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(schedulerUserSearchedADifferentMonth(params))
      .catch(createOnError(1151, params));
  }

  // 1152
  async schedulerUserChoosesADay(params: BiParams<schedulerUserChoosesADayParams>): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(schedulerUserChoosesADay(params))
      .catch(createOnError(1152, params));
  }

  // 1153
  async schedulerUserClickedOnASlot(params: BiParams<schedulerUserClickedOnASlotParams>): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(schedulerUserClickedOnASlot(params))
      .catch(createOnError(1153, params));
  }

  // 1159
  async chatbotClickOnSolution(params: BiParams<chatbotClickOnSolutionParams>): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(chatbotClickOnSolution(params))
      .catch(createOnError(1159, params));
  }

  // 1162
  async chatbotNotifications(params: BiParams<chatbotNotificationsParams>): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(chatbotNotifications(params))
      .catch(createOnError(1162, params));
  }

  // 1172
  async chatbotErrorMessagePresented(
    params: BiParams<chatbotErrorMessagePresentedSrc4Evid1172Params>,
  ): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(chatbotErrorMessagePresentedSrc4Evid1172(params))
      .catch(createOnError(1172, params));
  }

  // 1173
  async resendButtonClicked(params: BiParams<aiChatbotResendButtonClickedSrc4Evid1173Params>): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(aiChatbotResendButtonClickedSrc4Evid1173(params))
      .catch(createOnError(1173, params));
  }

  // 1175
  async chatbotConnectionLostMessagePresented(
    params: BiParams<chatbotConnectionLostMessagePresentedSrc4Evid1175Params>,
  ): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(chatbotConnectionLostMessagePresentedSrc4Evid1175(params))
      .catch(createOnError(1175, params));
  }

  // 7400
  async chatbotSendMessage(params: BiParams<chatbotSendMessageSrc4Evid7400Params>): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(chatbotSendMessageSrc4Evid7400(params))
      .catch(createOnError(7400, params));
  }

  // 7401
  async chatbotErrorMessageAppears(
    params: BiParams<chatbotErrorMessageAppearsSrc4Evid7401Params>,
  ): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(chatbotErrorMessageAppearsSrc4Evid7401(params))
      .catch(createOnError(7401, params));
  }

  async chatbotGeneralClientLog(params: BiParams<chatbotGeneralClientLogParams>): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(chatbotGeneralClientLog(params))
      .catch(createOnError(1174, params));
  }

  // 1134
  async chatbotContactFlowQuickAccessAvailable(
    params: BiParams<chatbotContactFlowQuickAccessAvailableSrc4Evid1134Params>,
  ): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(chatbotContactFlowQuickAccessAvailableSrc4Evid1134(params))
      .catch(createOnError(1134, params));
  }

  // 1136
  async chatbotAnswerFeedbackPresented(
    params: BiParams<aiChatbotAnswerFeedbackPresentedSrc4Evid1136Params>,
  ): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(aiChatbotAnswerFeedbackPresentedSrc4Evid1136(params))
      .catch(createOnError(1136, params));
  }

  // 1137
  async chatbotAnswerFeedbackClicked(
    params: BiParams<aiChatbotAnswerFeedbackClickedSrc4Evid1137Params>,
  ): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(aiChatbotAnswerFeedbackClickedSrc4Evid1137(params))
      .catch(createOnError(1137, params));
  }

  // 1138
  async chatbotAnswerFeedbackReasonButtonClicked(
    params: BiParams<aiChatbotAnswerFeedbackReasonButtonClickedSrc4Evid1138Params>,
  ): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(aiChatbotAnswerFeedbackReasonButtonClickedSrc4Evid1138(params))
      .catch(createOnError(1138, params));
  }

  // 1139
  async chatbotAnswerFeedbackFreeText(
    params: BiParams<aiChatbotAnswerFeedbackFreeTextSrc4Evid1139Params>,
  ): Promise<void> {
    const referralFromSession = sessionStorage.getItem('referral');

    await this._chatbotLogger
      .updateDefaults({
        ...defaultBiFields,
        referral: referralFromSession ?? defaultBiFields.referral,
      })
      .report(aiChatbotAnswerFeedbackFreeTextSrc4Evid1139(params))
      .catch(createOnError(1139, params));
  }

  // 1502
  async helpWidgetPageViewNew(
    state: TRootState,
    params: Partial<helpWidgetPageViewNewSrc4Evid1502Params>,
  ): Promise<void> {
    await this.reportWithAutoEnhancement(state, helpWidgetPageViewNewSrc4Evid1502, 1502, params);
  }

  // 1504
  async helpWidgetPageEngagementNew(
    state: TRootState,
    params: Partial<helpWidgetPageEngagementNewSrc4Evid1504Params>,
  ): Promise<void> {
    await this.reportWithAutoEnhancement(state, helpWidgetPageEngagementNewSrc4Evid1504, 1504, params);
  }

  // 1505
  async helpWidgetItemOnViewNew(
    state: TRootState,
    params: Partial<helpWidgetItemOnViewNewSrc4Evid1505Params>,
  ): Promise<void> {
    if (renderModel.isFullWidth()) {
      return;
    }
    await this.reportWithAutoEnhancement(state, helpWidgetItemOnViewNewSrc4Evid1505, 1505, params);
  }

  // 1506
  async helpWidgetItemClickNew(
    state: TRootState,
    params: Partial<helpWidgetItemClickNewSrc4Evid1506Params>,
  ): Promise<void> {
    if (renderModel.isFullWidth()) {
      return;
    }
    await this.reportWithAutoEnhancement(state, helpWidgetItemClickNewSrc4Evid1506, 1506, params);
  }

  // 1507
  async helpWidgetPageErrorNew(
    state: TRootState,
    params: Partial<helpWidgetPageErrorNewSrc4Evid1507Params>,
  ): Promise<void> {
    await this.reportWithAutoEnhancement(state, helpWidgetPageErrorNewSrc4Evid1507, 1507, params);
  }

  // 1509
  async helpWidgetSearchResultsNew(
    state: TRootState,
    params: Partial<helpWidgetSearchResultsNewSrc4Evid1509Params>,
  ): Promise<void> {
    const searchSessionId = selectSearchSessionId(state);
    const enhancedParams = { ...params, search_session_id: searchSessionId };
    await this.reportWithAutoEnhancement(state, helpWidgetSearchResultsNewSrc4Evid1509, 1509, enhancedParams);
  }

  // 1510
  async helpWidgetClickOnAnswerOrResultNew(
    state: TRootState,
    params: Partial<helpWidgetClickOnAnswerOrResultNewSrc4Evid1510Params>,
  ): Promise<void> {
    const searchSessionId = selectSearchSessionId(state);
    const enhancedParams = {
      ...params,
      search_session_id: searchSessionId,
      // Ensure clicked_url is always absolute for BI validation
      clicked_url: params.clicked_url ? toAbsoluteUrl(params.clicked_url) : undefined,
    };

    await this.reportWithAutoEnhancement(
      state,
      helpWidgetClickOnAnswerOrResultNewSrc4Evid1510,
      1510,
      enhancedParams,
    );
  }

  // 1520
  async fullContactPageArticleView(
    state: TRootState,
    params: Partial<fullContactPageArticleViewSrc4Evid1520Params>,
  ): Promise<void> {
    await this.reportWithAutoEnhancement(state, fullContactPageArticleViewSrc4Evid1520, 1520, params);
  }

  // 1521
  async fullContactPageArticleEngagement(
    state: TRootState,
    params: Partial<fullContactPageArticleEngagementSrc4Evid1521Params>,
  ): Promise<void> {
    await this.reportWithAutoEnhancement(state, fullContactPageArticleEngagementSrc4Evid1521, 1521, params);
  }

  // 1149
  async chatbotShowSourcesButtonClickedInAnAnswer(
    state: TRootState,
    params: Partial<aiChatbotShowSourcesButtonClickedInAnAnswerSrc4Evid1149Params>,
  ): Promise<void> {
    await this.reportWithAutoEnhancement(
      state,
      aiChatbotShowSourcesButtonClickedInAnAnswerSrc4Evid1149,
      1149,
      params,
    );
  }

  // 1146
  async chatbotClickButtonOnHeader(
    state: TRootState,
    params: Partial<chatbotClickButtonOnHeaderSrc4Evid1146Params>,
  ): Promise<void> {
    await this.reportWithAutoEnhancement(state, chatbotClickButtonOnHeaderSrc4Evid1146, 1146, params);
  }

  // 1147
  async sitePickerEvent(
    state: TRootState,
    params: Partial<SitePickerEventSrc4Evid1147Params>,
  ): Promise<void> {
    await this.reportWithAutoEnhancement(state, sitePickerEventSrc4Evid1147, 1147, params);
  }

  // 112
  async caraIsOffered(
    state: TRootState,
    params: Partial<caraVoiceAssistantCaraIsOfferedSrc4Evid112Params>,
  ): Promise<void> {
    await this.reportWithAutoEnhancement(state, caraVoiceAssistantCaraIsOfferedSrc4Evid112, 112, params);
  }

  // 1148
  async chatbotSatisfactionSurveyInteraction(
    state: TRootState,
    params: Partial<chatbotHelpmateSatisfactionSurveyInteractionSrc4Evid1148Params>,
  ): Promise<void> {
    await this.reportWithAutoEnhancement(
      state,
      chatbotHelpmateSatisfactionSurveyInteractionSrc4Evid1148,
      1148,
      params,
    );
  }

  // 8201
  async pageClick(state: TRootState, params: Partial<pageClickParams>): Promise<void> {
    await this.reportWithAutoEnhancement(state, pageClick, 8201, params);
  }
}

export const biLogger = new BiLogger();
